<template>
  <div style="display: flex">
    <div style="width: 50%">
      <!-- <draggable v-model="myArray" handle=".view-drag" group="a">
        <hm-card  v-for="element in myArray1" :key="element.id"><a-button>{{element.name}}</a-button></hm-card>
      </draggable> -->
      <div id="items1">
        <hm-card
          v-for="element in myArray1"
          :key="element.id"
          :select="element.id == selectCardId ? true : false"
          @click.native="selectCard(element.id)"
        ><a-button>{{element.name}}</a-button></hm-card>
      </div>
    </div>
    <div id="iframe" style="width: 50%">
      <!-- <iframe width="100%" height="100%" src="demo1" scrolling="no" frameborder="0" ></iframe> -->
    </div>
    <!-- <hm-card v-for="element in myArray" :key="element.id" class="item">
			<a-button>{{ element.name }}</a-button>
		</hm-card> -->
    <!-- <hm-card><a-button>点击按钮</a-button></hm-card>
		<hm-card><a-button>点击按钮</a-button></hm-card>
		<hm-card><a-button>点击按钮</a-button></hm-card> -->
  </div>
</template>

<script>
import HmCard from "@/components/HmCard.vue";
import draggable from "vuedraggable";
import Sortable from "sortablejs";

export default {
  components: {
    HmCard,
    draggable,
  },
  data() {
    return {
      enabled: true,
      selectCardId: null,
      myArray1: [
        { name: "John", id: 0 },
        { name: "Joao", id: 1 },
        { name: "Jean", id: 2 },
      ],
      myArray2: [
        { name: "1", id: 0 },
        { name: "2", id: 1 },
        { name: "3", id: 2 },
      ],
      dragging: false,
    };
  },
  methods: {
    selectCard(id){
      if(id == this.selectCardId){
        this.selectCardId = null
      }else{
        this.selectCardId = id
      }
    },
    test() {
      var that = this;
      var el1 = document.getElementById("items1");
      // 常用
      Sortable.create(el1, {
        handle: ".view-drag",
        group: "hm-card",
      });
      // var el2 = document.getElementById("items2");
      // // 常用
      // Sortable.create(el2, {
      //   handle: ".view-drag",
      //   group: "hm-card",
      // });

      var iframe = document.createElement("iframe");

      iframe.src = "demo1";
      iframe.width = "100%";
      iframe.height = "100%";
      iframe.onload = function() {
        var doc = iframe.contentDocument;
        console.log(`iframe.contentDocument: `, iframe.contentWindow.document);
        var el3 = doc.getElementById("items3");
        Sortable.create(el3, {
          handle: ".view-drag",
          group: {
            name: "hm-card",
            pull: false,
          },
        });
      };
      document.getElementById("iframe").appendChild(iframe);
    },
  },
  mounted() {
    this.test();
  },
};
</script>
